import { gql } from 'apollo-angular';

const UPDATE_PUBLISH_RFP_DETAILS = gql`
  mutation UpdateRfpPublishedDetail(
    $rfpId: Long!
    $contactName: String!
    $contactEmail: String!
    $contactPhone: String!
    $projectedRfpDate: Date!
    $requirements: String!
    $description: String

  ) {
    updateRfpPublishedDetail(
      updateRfpPublishedDetailRequest: {
        rfpId: $rfpId
        contactName: $contactName
        contactEmail: $contactEmail
        contactPhone: $contactPhone
        projectedRfpDate: $projectedRfpDate
        requirements: $requirements
        description: $description
      }
    ) {
      id
      publishedDate
      status
    }
  }
`;

export default UPDATE_PUBLISH_RFP_DETAILS;
